// App.js
import React, { useEffect, useState } from "react";
import { auth } from "./firebaseConfig";
import { GoogleAuthProvider, signInWithRedirect, getRedirectResult } from "firebase/auth";

function App() {
  const [user, setUser] = useState(null);

  // Check if the user has been redirected back with a sign-in result.
  useEffect(() => {
    getRedirectResult(auth)
      .then((result) => {
        if (result && result.user) {
          setUser(result.user);
        }
      })
      .catch((error) => {
        console.error("Error retrieving redirect result:", error);
      });
  }, []);

  // Function to start Google sign-in via redirect.
  const handleGoogleSignIn = () => {
    const provider = new GoogleAuthProvider();
    signInWithRedirect(auth, provider);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      {user ? (
        <div>
          <h2>Welcome, {user.displayName}</h2>
          <p>You have successfully signed in using your custom domain.</p>
        </div>
      ) : (
        <button onClick={handleGoogleSignIn}>
          Login with Google
        </button>
      )}
    </div>
  );
}

export default App;